import React from 'react';
import { v4 as uuid } from 'uuid';
import { useAriaLive } from '@ally/use-aria-live';
import { deprecated } from '@ally/metronome-icons';
import { VisuallyHiddenDiv } from './shared';
import { Button } from '../../Action';
const AddRemoveButtonAriaDescribedBy = ({ areAllSelected, getAddRemoveButtonAriaDescribedBy, areItemsDisabled, id, }) => {
    const content = getAddRemoveButtonAriaDescribedBy(areAllSelected, areItemsDisabled);
    return (React.createElement(VisuallyHiddenDiv, { id: id, "aria-hidden": "true" }, content));
};
const AddRemoveAllButton = ({ values, optionValues, onChange, getAddRemoveButtonAriaDescribedBy, getAriaLiveAddRemoveAll, getAddRemoveAllButtonText, }) => {
    const { all: allValues, isEnabled: enabledValues, isDisabled: disabledValues, } = optionValues;
    const { current: addRemoveButtonAriaDescribedByID } = React.useRef(uuid());
    const { announcePolite } = useAriaLive();
    const areAllEnabledSelected = !enabledValues.some(value => {
        return !values.has(value);
    });
    const disabledSelectedValues = disabledValues.reduce((acc, value) => {
        if (values.has(value)) {
            return [...acc, value];
        }
        return acc;
    }, []);
    const areAllSelected = allValues.size === values.size;
    const areItemsDisabled = !!disabledValues.length;
    const addRemoveAllText = getAddRemoveAllButtonText(areAllEnabledSelected);
    const handleAddRemoveAll = React.useCallback(() => {
        const ariaLiveContent = getAriaLiveAddRemoveAll(areAllEnabledSelected, areItemsDisabled);
        if (areAllEnabledSelected) {
            announcePolite(ariaLiveContent);
            onChange([...disabledSelectedValues]);
        }
        if (!areAllEnabledSelected) {
            announcePolite(ariaLiveContent);
            onChange([...disabledSelectedValues, ...enabledValues]);
        }
    }, [
        areAllSelected,
        areAllEnabledSelected,
        allValues,
        disabledSelectedValues,
        announcePolite,
    ]);
    const map = areAllEnabledSelected ? deprecated.muiMinus : deprecated.muiPlus;
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { variant: "link", icon: { map, position: 'left', size: 'xl' }, text: addRemoveAllText, onClick: handleAddRemoveAll, "aria-describedby": addRemoveButtonAriaDescribedByID }),
        React.createElement(AddRemoveButtonAriaDescribedBy, { areAllSelected: areAllEnabledSelected, id: addRemoveButtonAriaDescribedByID, getAddRemoveButtonAriaDescribedBy: getAddRemoveButtonAriaDescribedBy, areItemsDisabled: areItemsDisabled })));
};
export { AddRemoveAllButton };
//# sourceMappingURL=AddRemoveAllButton.js.map